import React from 'react';
import T from 'prop-types';
import classNames from 'classnames';
import ToggleContainer from '../Containers/toggleContainer';
import withSearch from '../Containers/withSearch';
import ItemList from './item-list';

const SearchLinkList = (props) => {
  const {
    Heading,
    SearchResult: { TotalHits, SearchHits },
  } = props;

  if (!SearchHits || SearchHits.length === 0) return null;

  return (
    <ToggleContainer {...props}>
      {({ open, toggle }) => (
        <div className="search-link-list">
          <button
            className="search-link-list__btn"
            type="button"
            onClick={toggle}
            aria-expanded={props.isOpen}
            aria-controls={`search-link-list-${props.BlockId}`}
          >
            <i
              className={classNames({
                'chevron--search-link': true,
                'chevron--search-link--is-open': open,
              })}
            />
            <span className="search-link-list__heading">{`${Heading} (${TotalHits} st)`}</span>
          </button>

          <div
            id={`search-link-list-${props.BlockId}`}
            aria-hidden={!open}
            className={classNames({
              'search-link-list__content': true,
              'search-link-list__content--is-expanded': open,
            })}
          >
            <ItemList {...props} />
          </div>
        </div>
      )}
    </ToggleContainer>
  );
};

SearchLinkList.propTypes = {
  BlockId: T.oneOfType([T.string, T.number]),
  Heading: T.string,
  isOpen: T.bool,
  /** See <Item> component */
  SearchHits: T.array,
};

export default withSearch(SearchLinkList, 'SearchLinkList');
export { SearchLinkList };
